import shellReducer, { $$initialState as $$shellState } from './shellReducer';

export default {
  $$shellStore: shellReducer,
};

export const initialStates = {
  $$shellState,
};
